import { BaseModel } from '../../base/base-model'
import { PriceModel } from '../../base/price'
import { ListingPrivateDataModel } from '../listing-private-data'
import { ListingPublicDataModel } from '../listing-public-data'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class CreateListingModel extends BaseModel {
  /**
   * @param {string} title
   * @param {string} [description]
   * @param {loavies.models.base.PriceModel} [price]
   * @param {Array<string>} [images]
   * @param {Object} [privateData]
   * @param {Object} [publicData]
   */
  constructor({
    title,
    description,
    price,
    images,
    privateData,
    publicData,
  }) {
    super()

    /** @type {string} */
    this.title = title

    /** @type {string} */
    if (!this.isUndefined(description)) this.description = description

    /** @type {loavies.models.base.PriceModel} */
    if (!this.isUndefined(price)) this.price = new PriceModel(price)

    /** @type {Array<string>} */
    if (!this.isUndefined(images)) this.images = images

    /** @type {loavies.models.listing.ListingPrivateDataModel} */
    if (!this.isUndefined(privateData)) this.privateData = new ListingPrivateDataModel(privateData)

    /** @type {loavies.models.listing.ListingPublicDataModel} */
    if (!this.isUndefined(publicData)) this.publicData = new ListingPublicDataModel(publicData)
  }
}
